import { useEffect } from "react";
import { useLocale } from "./localization";
import "./account-action.css";

export const ACCOUNT_REDIRECT_DELAY_MS = 5000;

export function AccountSuccess({
  kind,
  onContinue,
}: {
  kind: "mfa" | "password";
  onContinue: () => void;
}) {
  const { locale } = useLocale();
  const ar = locale === "ar-SA";
  useEffect(() => {
    const timer = window.setTimeout(onContinue, ACCOUNT_REDIRECT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [onContinue]);
  return (
    <main className="account-action-page" dir={ar ? "rtl" : "ltr"}>
      <section
        className="account-action-card"
        aria-labelledby="account-success-title"
      >
        <img
          className="account-action-brand"
          src="/email/institutional-header-v1.png"
          alt={
            ar ? "جامعة طيبة | وادي طيبة" : "Taibah University | Taibah Valley"
          }
        />
        <span className="account-success-icon" aria-hidden="true">
          ✓
        </span>
        <h1 id="account-success-title">
          {kind === "mfa"
            ? ar
              ? "تم ربط Google Authenticator بنجاح"
              : "Google Authenticator linked successfully"
            : ar
              ? "تم حفظ كلمة المرور بنجاح"
              : "Password saved successfully"}
        </h1>
        <p role="status">
          {ar
            ? "سيتم نقلك تلقائيًا خلال 5 ثوانٍ إلى الصفحة الرئيسية للوحة المتابعة التنفيذية لمؤتمرات جامعة طيبة لتسجيل الدخول."
            : "You will be redirected in 5 seconds to the Taibah University Conferences Executive Dashboard sign-in page."}
        </p>
        <p className="account-action-muted">
          {ar
            ? "إذا لم يتم الانتقال تلقائيًا، اضغط على الزر أدناه."
            : "If you are not redirected automatically, use the button below."}
        </p>
        <button
          className="button button--primary"
          type="button"
          onClick={onContinue}
        >
          {ar ? "الانتقال إلى تسجيل الدخول" : "Continue to sign in"}
        </button>
      </section>
    </main>
  );
}
